import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, options } from '@apexdesigner/schema-tools';

export const horseGroup = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z
      .string()
      .describe(
        'Name of the group, e.g. "Claiborne 2026 Mares" (legacy column `description`).',
      ),

    category: options([
      { value: 'Mare', name: 'Mare' },
      { value: 'Stallion', name: 'Stallion' },
    ]).describe('Whether the group holds mares or stallions.'),

    subCategory: options([
      {
        value: 'Mare Book',
        name: 'Mare Book',
        description: 'Mares booked to a stallion or farm',
      },
      {
        value: 'Sire Line',
        name: 'Sire Line',
        description: 'Stallions from one sire line',
      },
      { value: 'General', name: 'General' },
    ])
      .nullable()
      .optional()
      .describe('Mare book, sire line, or general.'),

    legacyId: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .describe('The legacy `groups.group_id`.'),

    members: hasMany('HorseGroupMember'),

    groupMatches: hasMany('GroupMatch', 'groupId'),
  })
  .describe(
    "A named list of mares or stallions, e.g. a farm's book of mares or a sire\nline, used to run one mare against many stallions (Group MareMatch).",
  )
  .meta({ readAs: '{name}' })
  .as('HorseGroup');

export { horseGroup as horseGroupSchema };
